import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Amplify } from 'aws-amplify';

// Initialize app
async function initializeApp() {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  
  try {
    const config = {
      Auth: {
        Cognito: {
          region: process.env.REACT_APP_AWS_REGION,
          userPoolId: process.env.REACT_APP_USER_POOL_ID,
          userPoolClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID,
          loginWith: {
            oauth: {
              domain: process.env.REACT_APP_COGNITO_DOMAIN,
              scopes: ['email', 'openid', 'profile'],
              redirectSignIn: [
                //process.env.REACT_APP_LOCAL_REDIRECT_URL,
                process.env.REACT_APP_REDIRECT_SIGN_IN
              ],
              redirectSignOut: [
                //process.env.REACT_APP_LOCAL_REDIRECT_URL,
                process.env.REACT_APP_REDIRECT_SIGN_OUT
              ],
              responseType: 'code'
            }
          }
        }
      },
      API: {
        REST: {
          //improveResume: {
          //  endpoint: authConfig.apiConfig.endpoint,
          //  region: authConfig.apiConfig.region
          //}
        }
      }
    };

    Amplify.configure(config);

    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  } catch (error) {
    console.error('Initialization error:', error);
    root.render(<div>Error loading app: {error.message}</div>);
  }
}

// Start the app
initializeApp();